import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "Inicio", href: "#inicio", anchor: true },
  { label: "Sobre Nosotros", href: "#nosotros", anchor: true },
  { label: "Servicios", href: "#servicios", anchor: true },
  { label: "Galería", href: "/galeria", anchor: false },
  { label: "Contacto", href: "#contacto", anchor: true },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    if (isHome) {
      const target = document.querySelector(href);
      if (target) target.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const target = document.querySelector(href);
        if (target) target.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  const isGalleryPage = location.pathname === "/galeria";
  const navBg = scrolled || isGalleryPage ? "bg-white shadow-sm" : "bg-transparent";
  const textColor = scrolled || isGalleryPage ? "text-gray-700" : "text-white";
  const logoColor = scrolled || isGalleryPage ? "text-teal-700" : "text-white";

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-24">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2 cursor-pointer"
        >
          <img
            src="https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/01ecbd60-a775-43b2-95ff-ed82a8bcfa34_logo-insercom.ps.png?v=560c1c7d20a19292910cedef55066a8d"
            alt="INSERCOM Logo"
            className="h-20 w-auto object-contain"
            style={{ filter: scrolled || isGalleryPage ? "none" : "brightness(0) invert(1)" }}
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) =>
            item.anchor ? (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleAnchor(e, item.href)}
                className={`text-sm font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap hover:text-teal-500 ${textColor}`}
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setMenuOpen(false)}
                className={`text-sm font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap hover:text-teal-500 ${
                  isGalleryPage ? "text-teal-600" : textColor
                }`}
              >
                {item.label}
              </Link>
            )
          )}
          <a
            href="#contacto"
            onClick={(e) => handleAnchor(e, "#contacto")}
            className="bg-teal-600 hover:bg-teal-700 text-white text-sm font-bold px-5 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Cotizar
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden text-2xl cursor-pointer ${scrolled || isGalleryPage ? "text-teal-700" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-md px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) =>
            item.anchor ? (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleAnchor(e, item.href)}
                className="text-gray-700 font-semibold text-sm cursor-pointer hover:text-teal-600"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setMenuOpen(false)}
                className="text-gray-700 font-semibold text-sm cursor-pointer hover:text-teal-600"
              >
                {item.label}
              </Link>
            )
          )}
          <a
            href="#contacto"
            onClick={(e) => handleAnchor(e, "#contacto")}
            className="bg-teal-600 text-white text-center text-sm font-bold px-5 py-2 rounded-full cursor-pointer"
          >
            Cotizar
          </a>
        </div>
      )}
    </header>
  );
}